import "./styles.css";
import React, { useState } from "react";

import { HttpRequest } from "../../component/service/HttpRequest";
import { setCookie } from "../../component/service/CookieManagement";
import { useAuth } from "../../component/service/Authentication";

import Spinner from "../../component/spinner";

import {
  useGlobalContext,
  setAuthentication,
  setConfigServer,
} from "../../component/service/GlobalContext";

import IconLogin from "../../assets/images/login-icon.png";
import { LuEyeOff } from "react-icons/lu";
import { IoEyeOutline } from "react-icons/io5";

function LoginPage({ placeholder = "Password" }) {
  const [showPassword, setShowPassword] = useState(false); // สถานะ true = show text, false = show password
  const openPassword = () => {
    setShowPassword((prev) => !prev); // สลับสถานะ
  };
  const [globalState, setGlobalState] = useGlobalContext();

  const [formControl, setFormControl] = React.useState({
    username: "",
    password: "",
  });

  const [stateLogin, setStateLogin] = React.useState("loading"); 
  // ready, false, loading, success
  const getConfigServer = async () => {};

  const handleSubmit = (event) => {
    event.preventDefault();
    setStateLogin("loading");
  };

 // Check Authen
  React.useEffect(() => {
    const controller = new AbortController();
    setStateLogin("success");
    let authenData = {
      token: "DUMMY-TOKEN",
      user: "DUMMY-USER"
    }

    setTimeout(async () => {
      await getConfigServer();
      setAuthentication(setGlobalState, authenData);
    }, 500);

    return () => {
      controller.abort();
    };
  }, [globalState.auth]);

  return (
    <div className="main-content bg-login">
      <div className="body-form">
       
        
      </div>
    </div>
  );
}

export default LoginPage;
